import React from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import BackAnchor from 'shared/components/BackAnchor'

const ScreeningQuestionView = ({ t, i18n }) => {
  const history = useHistory()


  const yesClick = () => {
    history.push(`/${i18n.language}${t('routes.address_type_change')}`)
  }

  const noClick = () => {
    history.push(`/${i18n.language}${t('routes.screening_question_no')}`)
  }

  return (
    <div className="container">
      <main>
        <article>
          <BackAnchor backPath='routes.privacy_notice' />
          <div className="row">
            <div className="col-xs-12">
              <h1>{t('screening_question.do_you_know')}</h1>
              <div className='helper_content'>
                <blockquote>
                  <p>
                    {t('screening_question.your_licence')}
                  </p>
                </blockquote>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <button
                className='ns-btn-yes-no btn-default'
                style={{ marginRight: '20px' }}
                value={t('screening_question.yes')}
                name={t('screening_question.yes')}
                onClick={yesClick}
              >
                {' '}
                {t('screening_question.yes')}
              </button>
              <button
                className='ns-btn-yes-no btn-default'
                style={{ marginRight: '20px' }}
                value={t('screening_question.no')}
                name={t('screening_question.no')}
                onClick={noClick}
              >
                {' '}
                {t('screening_question.no')}
              </button>
              <a
                onClick={() => history.push(`/${i18n.language}${t('routes.screening_question_not_sure')}`)}
                href={`/${i18n.language}${t('routes.screening_question_not_sure')}`}
              >
                {t('screening_question.im_not_sure')}
              </a>
            </div>
          </div>
        </article>
      </main >
    </div >
  )
}

export default withTranslation('common')(ScreeningQuestionView)
